import React from "react";

function PlanBtn() {
  return <button className="planBtn">start free trial</button>;
}

export default PlanBtn;
